var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Campaigns = MDB.DPN.Campaigns || {};
MDB.DPN.Campaigns.Editor = MDB.DPN.Campaigns.Editor || {};

(function() {

	var _atlValues = [
		'DD4BDF3F-2D04-49C7-88A2-409578A3F0A5',
		'713D5F42-211D-4554-B833-FA2D07AADFBA',
		'54AFDC99-3A6D-48FE-BC6C-F8D8C9AB58A0',
		'D93D5545-E772-4088-98F4-DE6C8B1208DC',
		'BC6F08EB-DC66-4F21-848C-0915C3817F45',
		'880FCC92-6070-4916-A25E-1535E5BB9F21',
		'590E207A-4748-4B99-A52C-D25904E05832',
		'68888B8A-8A83-4476-8E72-B58C581BCA76',
		'716DD608-0F0E-41DC-8D37-486CA94E8E4A',
		'7F56EAB6-3A21-4B1E-B2BC-15093EB4431C',
		'71B51E55-00B1-4996-859A-EC4D6BEEE0D1',
		'574BAD80-3D4B-4D94-A1B3-683C5ADE87CE',
		'E8A9D61A-0D19-44F6-BA25-B08C956E9D17',
		'A60F9092-2B9B-49B4-B02B-351BFC7629E2',
		'80445381-564E-4717-AA14-D53C39718BCD',
		'D7DACCD5-F2F0-4DA1-B7BB-484D62110FC4',
		'D12E7AC9-3AC0-4D26-88AD-8C2AB5BC970E'
	];

	var _btlValues = [
		'DD4BDF3F-2D04-49C7-88A2-409578A3F0A5',
		'713D5F42-211D-4554-B833-FA2D07AADFBA',
		'54AFDC99-3A6D-48FE-BC6C-F8D8C9AB58A0',
		'D93D5545-E772-4088-98F4-DE6C8B1208DC',
		'BC6F08EB-DC66-4F21-848C-0915C3817F45',
		'880FCC92-6070-4916-A25E-1535E5BB9F21',
		'590E207A-4748-4B99-A52C-D25904E05832',
		'68888B8A-8A83-4476-8E72-B58C581BCA76',
		'716DD608-0F0E-41DC-8D37-486CA94E8E4A',
		'7F56EAB6-3A21-4B1E-B2BC-15093EB4431C'
	];

	var _types;

	var _editor,
	_modal,
	_saveBtn;

	$.extend(MDB.DPN.Campaigns.Editor, {
		init: function(types) {
			_types = types;

			_editor = $('#editor-modal');
			_saveBtn = $('#editor-save-btn');
			
			_modal = {
				modalTitle: _editor.find('.modal-title'),
				modalBody: _editor.find('.modal-body'),
				modalFooter: _editor.find('.modal-footer')
			};

			_editor.on('hidden.bs.modal', function () {
				clearModal();
				clearAddedButtons();
				_saveBtn.unbind('click');
			});

			function clearModal() {
				_modal.modalTitle.empty();
				_modal.modalBody.empty();
			}

			function clearAddedButtons() {
				_modal.modalFooter.find('[data-type="added-btn"]').remove();
			}
		},
		load: function(title, url, loadCallback, saveCallBack) {
			
			if(MDB.DPN.Campaigns.Editor.load._isLoading) {
				return $.Deferred().promise();
			}

			MDB.DPN.Campaigns.Editor.load._isLoading = true;

			var def = $.Deferred();
		    _modal.modalTitle.html(title);

			_modal.modalBody.load(url, function () {
				if(loadCallback) {
					loadCallback(_editor);
				}

				if(saveCallBack) {
					_saveBtn.show();
					var form = _modal.modalBody.find('form');
					if(form.length) {

						_saveBtn.click(function (e) {
							e.preventDefault();
						
							if(form.valid()) {
								saveCallBack(form);
								_editor.modal('hide');
							}
						});

						//re-add form validation
						form.removeData(['validator', 'unobtrusiveValidation']);
						$.validator.unobtrusive.parse(form);
						form.data('validator').settings.ignore = "";
					}
				} else {
					_saveBtn.hide();
				}

				MDB.initKendoDatePickers(_modal.modalBody);
				MDB.initKendoMultiSelects(_modal.modalBody);
				MDB.initMdbFileUploads(_modal.modalBody);
				MDB.initKendoDropdownLists(_modal.modalBody);

				_editor.modal('show');

				MDB.DPN.Campaigns.Editor.load._isLoading = false;
				def.resolve(_editor);
			});

			return def.promise();
		},
		addButton: function (html) {
			var template = $(html);
			template.attr('data-type', 'added-btn');
			template.insertBefore(_saveBtn);
		},
		kendoListBoxSelectAll: function(kendoListbox) {
			var values = $.map(kendoListbox.dataSource.data(), function(dataItem) {
	            return dataItem.Value;
	        });
	        
	        kendoListbox.value(values);
		},
		kendoListBoxSelectTypeChannels: function(kendoListbox, type) {
			values = type === 'atl' ? _atlValues : _btlValues;
	        kendoListbox.value(values);
		},
		states: function () {
			return {
				create: 0,
				edit: 1
			};
		},
		type: function(text) {
			var match = _.find(_types, function (type) {
				if(type.text === text) {
					return type;
				}
			});

			return match.value;
		},
		buildEditorUrl: function(baseUrl, type, state, campaignId, parameters){
			parameters = parameters || [];
			
			var baseParameters = [{
				name: 'type',
				value: type
			}, {
				name: 'state',
				value: state
			}];

			if(campaignId) {
				baseParameters.push({
					name: 'campaignId',
					value: campaignId
				});
			}
			
			parameters.push.apply(parameters, baseParameters);

	        return buildUrl(baseUrl, parameters);
    	}
	});

	 function buildUrl(baseUrl, parameters) {
        var url = baseUrl;

        if(url.substring(url.Length-1) == '/') {
			url = url.substring(0, url.Length-1);
		}
		
        var count = 0;
        parameters.forEach(function (parameter) {
                url = url + ( count == 0 ? '?' : '&') + parameter.name + '=' + parameter.value;
            count++;
        });
        return url;
    }

})();